import { Box, Typography } from '@mui/material';
import { IconLink } from '@procureai/ui-mui';
import { isEmpty, isNil } from 'ramda';
import { Union } from 'ts-toolbelt';

import { TsrctSourceReference, TsrctSourcingCaseReference } from '@/generated/gql/graphql';
import { NBSP } from '~/common/constants';

export type SourceReferenceLink = Omit<
  Union.IntersectOf<TsrctSourceReference & TsrctSourcingCaseReference>,
  '__typename'
>;

export interface SourceReferenceLinksProps {
  values?: SourceReferenceLink[] | null;
}

export const SourceReferenceLinks = ({ values }: SourceReferenceLinksProps) => {
  if (isNil(values) || isEmpty(values)) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
      {values?.map((sourceReference) => (
        <>
          {sourceReference.url ? (
            <IconLink variant="body2" href={sourceReference?.url} key={sourceReference?.id}>
              {sourceReference?.sourceReference}
            </IconLink>
          ) : (
            <Typography variant="body2">{sourceReference?.sourceReference}</Typography>
          )}
          {NBSP}
        </>
      ))}
    </Box>
  );
};
